import I18n from 'I18n';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import isValidI18nKey from 'I18n/utils/isValidI18nKey';
import { SuccessIcon } from 'foundations-assets';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { IconCircle } from 'foundations-components/transitional/components/IconCircle';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledTD = styled(View)(({
  theme
}) => ({
  borderTop: `${theme.borderWidth['100']} solid ${theme.color['border-core-subtle']}`,
  borderRight: `${theme.borderWidth['100']} solid ${theme.color['border-core-subtle']}`,
  textAlign: 'center',
  padding: theme.space['200'],
  '&:last-child': {
    borderRight: 'none'
  }
}));
const FeatureTableBodyCell = ({
  feature,
  columnApiName,
  colSpan,
  minBlockSize
}) => {
  const hasShortLimit = feature.shortLimits && typeof feature.shortLimits[columnApiName] === 'string' && isValidI18nKey(feature.shortLimits[columnApiName]);
  return /*#__PURE__*/_jsx(StyledTD, {
    as: "td",
    colSpan: colSpan,
    children: /*#__PURE__*/_jsx(Flex, {
      minBlockSize: minBlockSize,
      alignItems: "center",
      justifyContent: "center",
      children: feature.productApiNames.includes(columnApiName) ? hasShortLimit ? /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: feature.shortLimits[columnApiName]
      }) : /*#__PURE__*/_jsx(IconCircle, {
        paddingInline: "200",
        paddingBlock: "200",
        icon: SuccessIcon,
        color: "fill-surface-default",
        backgroundColor: "icon-core-default",
        borderWidth: "0",
        size: "100",
        role: "img"
      }) : /*#__PURE__*/_jsx("span", {
        "aria-label": I18n.text('upgrades.featureTableMC0672.emptyCellAriaLabel')
      })
    })
  });
};
export default FeatureTableBodyCell;